export const breakpoints = ["32em", "48em", "64em", "80em"]

export const space = [0, 4, 8, 12, 16, 24, 32, 64, 128, 256, 512]

export const fonts = {
  sans: [
    "system-ui",
    "-apple-system",
    "BlinkMacSystemFont",
    '"SF Pro Text"',
    '"Roboto"',
    '"Segoe UI"',
    '"Oxygen"',
    '"Ubuntu"',
    '"Cantarell"',
    '"Fira Sans"',
    '"Droid Sans"',
    '"Helvetica Neue"',
    "sans-serif",
  ].join(", "),
}

export const fontSizes = [12, 14, 16, 20, 24, 32, 48, 64]

export const fontWeights = { normal: 400, medium: 500 }

export const lineHeights = {
  none: 1,
  tight: 1.25,
  normal: 1.5,
  loose: 2,
}

export const colors = {
  white: "#fff",
  "Ink Dark": "#14151A",
  Ink: "#42454D",
  "Ink Light": "#81868F",
  "Ink Lighter": "#A1A9B3",
  "UI Darker": "#CED2D9",
  "UI Dark": "#E8EAEF",
  UI: "#F1F2F5",
  "UI Light": "#F9FAFB",
  "UI White": "#FFFFFF",
  "Crimson Darker": "#742831",
  "Crimson Dark": "#BB4050",
  Crimson: "#EA5164",
  "Crimson Light": "#F4A8B1",
  "Crimson Lighter": "#FCE9EB",
  "Chromium Darker": "#22446D",
  "Chromium Dark": "#376DB0",
  Chromium: "#4589DC",
  "Chromium Light": "#A2C4ED",
  "Chromium Lighter": "#E7F0FB",
  "Uranium Darker": "#226147",
  "Uranium Dark": "#389C73",
  Uranium: "#46C490",
  "Uranium Light": "#A2E1C7",
  "Uranium Lighter": "#E7F7F1",
  "Sodium Darker": "#7F6034",
  "Sodium Dark": "#CC9B54",
  Sodium: "#FFC26A",
  "Sodium Light": "#FFE0B4",
  "Sodium Lighter": "#FFF7EC",
  "Lithium Darker": "#7F3A36",
  "Lithium Dark": "#CC5E57",
  Lithium: "#FF766D",
  "Lithium Light": "#FFBAB6",
  "Lithium Lighter": "#FFEDEC",
}

export const radii = [0, 4]

export const shadows = [
  "none",
  "0 0 0 1px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.1)",
  "0 0 0 1px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.1)",
  "inset 0 0 4px 0 rgba(0,0,0,0.25)",
]

export default {
  breakpoints,
  space,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  colors,
  radii,
  shadows,
}



// WEBPACK FOOTER //
// ./src/theme.js